<template>
  <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100vh;">
    <a-spin v-if="!ssoLoginOut" style="font-size: 16px;" size="large" tip="登录中，请稍后..."></a-spin>
    <a-spin v-if="ssoLoginOut" style="font-size: 16px;" size="large" tip="正在退出，请稍后..."></a-spin>
  </div>
</template>

<script>
import { getRequest } from '../Common/Utils/Utils';
// import {baseUrl} from '@/Utils/url.js'
// import {instance} from '@/Utils/axios'

export default {
  data() {
    return {
      ssoLoginOut: window.localStorage.getItem("ssoLoginOut")
    };
  },
  mounted() {
    if (getRequest('code')) {
      this.checkLogin();
    } else {
      if (this.ssoLoginOut) {
        this.backLogin();
        window.localStorage.removeItem("ssoLoginOut");
      } else {
        this.$router.push('/login');
      }
    }
  },
  methods: {
    setUserInfo(data) {
      let { userId, userName, email, code: userNo, userType, phoneNumber, clientId, } = data || {};
      return { userName, userId, email, userNo, userType, phoneNumber, clientId, };
    },
    backLogin() {
      let src = window.localStorage.getItem('loginOutSrc');
      var iframe = document.createElement("iframe");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("height", "500");
      iframe.setAttribute("style", "display: none");
      iframe.setAttribute("src", src);
      document.body.appendChild(iframe);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    checkLogin() {
      let code = getRequest('code');
      let state = getRequest('state');
      let source = getRequest('source') || 'newhope';
      this.$http.get(`/iot-auth/oauth/getToken/${source}`, { params: { code, state } }).then(res => {
        let { success, msg } = res;
        if (success) {
          let { accessToken, refreshToken, userName, userId } = res.data || {};
          this.userInfo = this.setUserInfo(res.data);
          window.localStorage.setItem('userInfo', JSON.stringify(res.data));
          window.localStorage.setItem('accessToken', accessToken);
          window.localStorage.setItem('userName', userName);
          window.localStorage.setItem('loginTime', new Date().getTime());
          window.localStorage.setItem('refreshToken', refreshToken);
          window.localStorage.setItem('staffId', userId);
          this.$store.commit('saveUserName', { userName: userName });
          window.localStorage.setItem('clientCode', code);
          window.localStorage.setItem('clientState', state);

          this.$router.push('/factory?name=选择工厂');
        } else {
          this.$message.warning(msg);
          this.$router.push('/login');
        }
      }).catch(() => {
        this.$router.push('/login');
      });
    }
  }
};
</script>